import { gsap } from 'gsap';

export function loaderEnter(el) {
  const flower = el.querySelector('.loader__flower');
  const text = el.querySelector('.loader__text');
  const tl = gsap.timeline();

  gsap.set(flower, { opacity: 0, transformOrigin: '50% 50%' });
  gsap.set(text, { scale: 0.6, opacity: 0, transformOrigin: '50% 50%' });

  gsap.to(flower, {
    rotation: '360',
    ease: 'power1.inOut',
    repeat: -1,
    duration: 8,
  });

  tl.addLabel('start')
    .to(flower, {
      scale: 0.8,
      opacity: 1,
      ease: 'bloom',
      duration: 2,
    }, 'start')
    .to(text, {
      scale: 1,
      opacity: 1,
    }, 'start+=0.8');

  return tl;
}

export function loaderLeave(el) {
  const flower = el.querySelector('.loader__flower');
  const text = el.querySelector('.loader__text');
  const tl = gsap.timeline({ delay: 1 });

  gsap.to(flower, {
    scale: 2.5,
    duration: 4,
    ease: 'bloom',
    delay: 1,
    onComplete: () => {
      gsap.killTweensOf(flower);
    },
  });

  tl.addLabel('start')
    .to(el, {
      opacity: 0,
      ease: 'bloom',
      duration: 2,
    }, 'start')
    .to(text, {
      scale: 0.8,
      opacity: 0,
    }, 'start');

  return tl;
}
